import React from "react";
import { cn } from "../../lib/cn";

/**
 * Универсальный input компонент системы "Школьное питание"
 */
export const Input = ({
  type = "text",
  placeholder = "",
  value = "",
  onChange,
  className = "",
  error = "",
  disabled = false,
  required = false,
  label = "",
  id = "",
  size = "md",
  noMargin = false,
  wrapperClassName = "",
  ...props
}) => {
  const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;

  const inputClasses = cn(
    "input-base",
    `input-${size}`,
    error && "input-error",
    className,
  );

  return (
    <div className={cn("w-full", !noMargin && "mb-4", wrapperClassName)}>
      {label && (
        <label
          htmlFor={inputId}
          className="block text-sm font-semibold text-[var(--color-text-secondary)] mb-1.5"
        >
          {label}
          {required && (
            <span className="text-[var(--color-accent-danger)] ml-1">*</span>
          )}
        </label>
      )}

      <div className="relative">
        <input
          type={type}
          id={inputId}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          required={required}
          className={inputClasses}
          {...props}
        />
      </div>

      {error && (
        <p className="mt-1.5 text-xs font-medium text-[var(--color-accent-danger)]">
          {error}
        </p>
      )}
    </div>
  );
};

/**
 * Универсальный textarea компонент
 */
export const Textarea = ({
  placeholder = "",
  value = "",
  onChange,
  className = "",
  error = "",
  disabled = false,
  required = false,
  label = "",
  id = "",
  size = "md",
  rows = 4,
  ...props
}) => {
  const textareaId =
    id || `textarea-${Math.random().toString(36).substr(2, 9)}`;

  const textareaClasses = cn(
    "input-base",
    `input-${size}`,
    "min-h-[100px] py-3",
    error && "input-error",
    className,
  );

  return (
    <div className="w-full mb-4">
      {label && (
        <label
          htmlFor={textareaId}
          className="block text-sm font-semibold text-[var(--color-text-secondary)] mb-1.5"
        >
          {label}
          {required && (
            <span className="text-[var(--color-accent-danger)] ml-1">*</span>
          )}
        </label>
      )}

      <div className="relative">
        <textarea
          id={textareaId}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          required={required}
          className={textareaClasses}
          rows={rows}
          {...props}
        />
      </div>

      {error && (
        <p className="mt-1.5 text-xs font-medium text-[var(--color-accent-danger)]">
          {error}
        </p>
      )}
    </div>
  );
};

export default Input;
